import ShareDialog from '@cdo/apps/code-studio/components/ShareDialog';
import React from 'react';
import { useSelector } from 'react-redux';
import { isSignedIn as getIsSignedIn } from '@cdo/apps/templates/currentUserRedux';
import popupWindow from '@cdo/apps/code-studio/popup-window';
/**
 * Wrapper around ShareDialog that plumbs in the necessary props for a Lab2 project.
 */
var Lab2ShareDialog = function (_a) {
    var shareUrl = _a.shareUrl;
    var isProjectLevel = useSelector(function (state) { var _a; return (_a = state.lab.levelProperties) === null || _a === void 0 ? void 0 : _a.isProjectLevel; }) || false;
    var appType = useSelector(function (state) { var _a; return (_a = state.lab.channel) === null || _a === void 0 ? void 0 : _a.projectType; });
    var channelId = useSelector(function (state) { var _a; return (_a = state.lab.channel) === null || _a === void 0 ? void 0 : _a.id; });
    var isSignedIn = useSelector(function (state) { return getIsSignedIn(state.currentUser); });
    var is13Plus = useSelector(function (state) { return !state.currentUser.under13; });
    // We don't currently support dance party projects in Lab2.
    var selectedSong = null;
    // TODO: support thumbnail url.
    var thumbnailUrl = null;
    // TODO: support abuse reporting.
    var exceedsAbuseThreshold = false;
    // TODO: When we support publishing, we can use this logic to determine if we can publish
    // const canPublish = isSignedIn && appType && AllPublishableProjectTypes.includes(appType);
    var canPublish = false;
    // TODO: this should come from labRedux once we support publishing.
    var isPublished = false;
    var canShareSocial = isSignedIn && is13Plus;
    if (!channelId || !appType) {
        return null;
    }
    return (React.createElement(ShareDialog, { isProjectLevel: isProjectLevel, allowSignedOutShare: appType === 'dance', shareUrl: shareUrl, selectedSong: selectedSong, thumbnailUrl: thumbnailUrl, isAbusive: exceedsAbuseThreshold, canPrint: appType === 'artist', canPublish: canPublish, isPublished: isPublished, channelId: channelId, appType: appType, onClickPopup: popupWindow, canShareSocial: canShareSocial, userSharingDisabled: false }));
};
export default Lab2ShareDialog;
